import { IsEmpty, IsValidEmail } from "../../utils/helper";

export default function IsValidUserProfileData(data, options = {}) {
  let errors = {};
  
  // Destructure options with defaults
  const {
    validatePersonalDetails = true,
    validateCompanyDetails = false,
    requiredFields = [],
    optionalFields = []
  } = options;

  // Personal Details Validation
  if (validatePersonalDetails) {
        if ('first_name' in data) {
        const firstName = data?.first_name?.trim();
        const nameRegex = /^[A-Za-z]+(\s[A-Za-z]+)*$/; 

        if (IsEmpty(firstName)) {
          errors.first_name = "First name is required";
        } else if (!nameRegex.test(firstName)) {
          errors.first_name = "First name must only contain letters";
        } else if (firstName.length < 3 || firstName.length > 30) {
          errors.first_name = "First name must be between 3 and 30 characters";
        }
      }

      if ('last_name' in data) {
        const lastName = data?.last_name?.trim();
        const nameRegex = /^[A-Za-z]+(\s[A-Za-z]+)*$/;

        if (IsEmpty(lastName)) {
          errors.last_name = "Last name is required";
        } else if (!nameRegex.test(lastName)) {
          errors.last_name = "Last name must only contain letters";
        } else if (lastName.length < 3 || lastName.length > 30) {
          errors.last_name = "Last name must be between 3 and 30 characters";
        }
      }
if ('email' in data) {
  const email = data?.email?.trim();

if (IsEmpty(email)) {
  errors.email = "Email is required";
} else {
  const trimmedEmail = email.trim();
  
  const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  if (!emailRegex.test(trimmedEmail)) {
    errors.email = "Invalid email format";
  } else if (trimmedEmail.length > 254) {
    errors.email = "Email is too long";
  } else if (trimmedEmail.includes("..")) {
    errors.email = "Email cannot contain consecutive dots";
  } else if (trimmedEmail.startsWith(".") || trimmedEmail.includes("@.") || trimmedEmail.includes(".@")) {
    errors.email = "Invalid email format";
  }
}
}

    if ('phone_number' in data) {
      const selectedCountry = data?.country_region;
      let phoneWithCountryCode = data.phone_number.startsWith('+')
       && data.phone_number
    
      if (IsEmpty(data?.phone_number)) {
        errors.phone_number = "Phone number is required";
      } 
      else if (!data.phone_number.startsWith('+') && !/^\d{10}$/.test(data.phone_number)) {
        errors.phone_number = "Phone number must be 10 digits";
      } 
      else if (!/^\+1\d{10}$|^\+44\d{10}$|^\+1\d{10}$/.test(phoneWithCountryCode)) {
        errors.phone_number = "Invalid phone number! Allowed country codes: +1 (USA/Canada), +44 (England)";
      } 
      else if (
        (selectedCountry === "United States of America" && !data.phone_number.startsWith("+1")) ||
        (selectedCountry === "Canada" && !data.phone_number.startsWith("+1")) ||
        (selectedCountry === "United Kingdom" && !data.phone_number.startsWith("+44"))
      ) {
        let correctCode = selectedCountry === "United Kingdom" ? '+44' : '+1';
        errors.phone_number = `Phone number must start with the correct country code(${correctCode}) for ${selectedCountry}.`;
      } 
      else {
        data.phone_number = phoneWithCountryCode;
      }
    }
  }

  // Company Details Validation
  if (validateCompanyDetails) {
    // Check required company fields
   if (requiredFields.includes('company_name') || (!optionalFields.includes('company_name') && 'company_name' in data)) {
      if (IsEmpty(data?.company_name)) {
        errors.company_name = "Company name is required";
      } else {
        const companyNameRegex = /^[A-Za-z0-9\s.,'&()-]+$/; // letters, numbers, spaces, and common business characters
        if (data.company_name.length < 2 || data.company_name.length > 50) {
          errors.company_name = "Company name must be between 2 and 50 characters";
        } else if (!companyNameRegex.test(data.company_name)) {
          errors.company_name = "Company name contains invalid characters";
        }
      }
    }

     if (requiredFields.includes('job_title') || (!optionalFields.includes('job_title') && 'job_title' in data)) {
      if (IsEmpty(data?.job_title)) {
        errors.job_title = "Job title is required";
      } else {
        const jobTitleRegex = /^[A-Za-z\s.,'&()-]+$/; // letters, spaces, and common job title characters
        if (data.job_title.length < 2 || data.job_title.length > 50) {
          errors.job_title = "Job title must be between 2 and 50 characters";
        } else if (!jobTitleRegex.test(data.job_title)) {
          errors.job_title = "Job title must only contain letters and common punctuation";
        }
      }
    }

   const nameRegex = /^[A-Za-z\s'-]+$/; // letters, spaces, hyphens, apostrophes

// For country_region (note: checking 'country_region' not 'country')
if (requiredFields.includes('country_region') || (!optionalFields.includes('country_region') && 'country_region' in data)) {
  if (IsEmpty(data?.country_region)) {
    errors.country_region = "Country is required";
  } else if (data.country_region.length < 3 || data.country_region.length > 30) {
    errors.country_region = "Country must be between 3 and 30 characters";
  } else if (!nameRegex.test(data.country_region)) {
    errors.country_region = "Country must only contain letters";
  }
}

if (requiredFields.includes('state') || (!optionalFields.includes('state') && 'state' in data)) {
  if (IsEmpty(data?.state)) {
    errors.state = "State is required";
  } else if (data.state.length < 3 || data.state.length > 30) {
    errors.state = "State must be between 3 and 30 characters";
  } else if (!nameRegex.test(data.state)) {
    errors.state = "State must only contain letters";
  }
}

// Also update address1 validation (you're using 'address1' not 'address_line1')
if (requiredFields.includes('address1') || (!optionalFields.includes('address1') && 'address1' in data)) {
  if (IsEmpty(data?.address1)) {
    errors.address1 = "Address is required";
  } else if (data.address1.length < 5) {
    errors.address1 = "Address must be at least 5 characters";
  }
}

// Address line 2 is optional (you're using 'address2' not 'address_line2')
if (!IsEmpty(data?.address2) && data.address2.length < 3) {
  errors.address2 = "Address line 2 must be at least 3 characters";
}

// Also update industry_focus validation
if (requiredFields.includes('industry_focus') || (!optionalFields.includes('industry_focus') && 'industry_focus' in data)) {
  if (IsEmpty(data?.industry_focus)) {
    errors.industry_focus = "Industry focus is required";
  } else if (!/^[A-Za-z0-9 _-]+$/.test(data.industry_focus)) {
    errors.industry_focus = "Industry focus may only contain letters, numbers, spaces, underscores (_), and hyphens (-)";
  } else if (data.industry_focus.length < 3 || data.industry_focus.length > 50) {
    errors.industry_focus = "Industry focus must be between 3 and 50 characters";
  }
}
   if (requiredFields.includes('pin_code') || (!optionalFields.includes('pin_code') && 'pin_code' in data)) {
      if (IsEmpty(data?.pin_code)) {
        errors.pin_code = "Zipcode is required";
      } else {
        // More flexible pin_code regex to handle different formats (US, UK, Canada, etc.)
        const zipcodeRegex = /^[A-Za-z0-9\s-]{3,10}$/;
        if (!zipcodeRegex.test(data.pin_code)) {
          errors.pin_code = "Invalid zipcode format";
        } else if (data.pin_code.replace(/[\s-]/g, '').length < 3) {
          errors.pin_code = "Zipcode must be at least 3 characters";
        }
      }
    }
  }

  return {
    isValid: IsEmpty(errors),
    errors: errors,
  };
}